import { useNavigate } from "react-router-dom";
import { routes } from "@/common/utils/routes";
import SealCheckIcon from "@/common/images/icons/seal-check.svg?react";
import { Button } from "components/buttons/Button";
import "./VerifiedButton.scss";

interface IVerifiedButton {
  onClick?: () => void;
}

export const VerifiedButton = ({ onClick }: IVerifiedButton) => {
  const navigate = useNavigate();

  const handleToVerify = () => {
    navigate(routes.verify());

    if (onClick) {
      onClick();
    }
  };

  return (
    <div className="VerifiedButton">
      <Button variant="secondary" onClick={handleToVerify} aria-label="Get Verified" type="button">
        <SealCheckIcon />
        Get Verified
      </Button>
    </div>
  );
};
